import React, { Component } from 'react';
import api from '../api';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import store from "../redux/store";
import moment from 'moment';
import FCalculator from '../custom-components/calculator';
import Calculator from "awesome-react-calculator";
import loadScripts  from '../../dassets/js/custom';

export class NGX extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ngx: {},
        }
      }
    
      componentDidMount() {
        loadScripts();
        this.fetchNgxs();
      }
    
      fetchNgxs() {
        api.get(`/getNgxIndex`)
        .then(response => {
            this.setState({
                ngx: response.data.data,
            });
        }).catch(error => {
            let err = store.getState().error;
            if (err) {
                toast.error(err.message);
                this.props.history.push(err.redirectUrl)
            }
            console.log(error)
        });
      }

    render() {
        return (
            <>
              {/* =================================
          Inner Header */}
              <div className="inner-header bg-light">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
                      <h1 className="breadcrumb-title mb-0">NGX Market Index</h1>
                    </div>
                    <div className="col-sm-6">
                      <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
                        <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
                        <li className="breadcrumb-item"><span>Research</span></li>
                        <li className="breadcrumb-item"><span>NGX Market Index</span></li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
              {/* =================================
        Inner Header */}
      
              {/* =================================
        Tab */}
              <section className="space-ptb">
                <div className="container">
                <div className="row">
                    <div className="col-lg-8 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h6 className="card-title">Market Index for {moment(this.state.ngx.created_at).format("MMM DD, YYYY")}</h6>
                                {/* <p className="card-description"> Here are the list of departments in your company
                                </p> */}
                                <div className="table-responsive mt-4">
                                    <table className="table table-striped">
                                        {/* <thead>
                                            <tr>
                                                <th> Id </th>
                                                <th> Code </th>
                                                <th> Name </th>
                                            </tr>
                                        </thead> */}
                                        <tbody>
                                        <tr>
                                            <td><strong>Index</strong></td>
                                            <td align="right">{this.state.ngx.index}</td>
                                        </tr>
                                        {/* <tr>
                                            <td><strong>Market Capt.(N'B)</strong></td>
                                            <td align="right">{this.state.ngx.market_cap}</td>
                                            </tr> */}
                                        <tr>
                                            <td><strong>Deals</strong></td>
                                            <td align="right">{this.state.ngx.deals}</td>
                                            </tr>
                                        <tr>
                                            <td><strong>Traded Volume</strong></td>
                                            <td align="right">{this.state.ngx.traded_volume}</td>
                                            </tr>
                                        <tr>
                                            <td><strong>Traded Value (N)</strong></td>
                                            <td align="right">{this.state.ngx.traded_value}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 grid-margin stretch-card">
                <div className="row mb-4">
                    <div className="col-12 stretch-card">
                  <FCalculator></FCalculator>
                </div>
                </div>
                <div className="row">
                    <div className="col-12 stretch-card">
                <div style={{
                  height: '24rem'
                }}>
                   <Calculator></Calculator> 
                </div></div></div>
                    </div>
                </div>
            </div>
            </section>
            </>
        )
    }
}

export default NGX
